import { getStoreCNSCInfoById } from 'services/api/store';
import { localeCountryCode } from 'services/chattt';
import { lazadaSellerCenterHostMap, shopeeLocalSellerHostMap } from 'services/config/region';
import toLowerCase from './toLowerCase';
import { openExternalURL } from './openExternalURL';
import { message } from 'antd';
import { tolgee } from 'services/i18n/tolgee';
import { isTiKTok } from 'lib/utils/isTikTok';

/**
 * 获取平台产品链接
 */
export async function getItemSellerCenterURL(
  storeId: string,
  externalItemId: string,
  channel?: string,
) {
  if (channel === 'TOKOPEDIA') {
    return `https://seller.tokopedia.com/edit-product/${externalItemId}`;
  }

  const res = await getStoreCNSCInfoById(storeId);
  const {
    data: {
      storeInfo: { externalType, region, storeType, externalStoreId },
    },
  } = res;

  if (externalType === 'SHOPEE') {
    if (storeType === 'CROSS') {
      return `https://seller.shopee.cn/portal/product/${externalItemId}/?cnsc_shop_id=${externalStoreId}`;
    } else {
      let lcc = 'CN';
      if (localeCountryCode) {
        lcc = localeCountryCode;
      }

      let host = `https://seller.shopee.co.${toLowerCase(region)}`;
      if (lcc !== 'CN') {
        const r = shopeeLocalSellerHostMap[toLowerCase(region)];
        if (r) {
          host = r;
        }
      }
      return `${host}/portal/product/${externalItemId}`;
    }
  }

  if (externalType === 'LAZADA') {
    if (storeType === 'CROSS') {
      return `https://gsp.lazada-seller.cn/apps/gsp/product/publish?productId=${externalItemId}`;
    } else {
      const host = lazadaSellerCenterHostMap[region];

      if (host) {
        return `${host}/apps/product/publish?productId=${externalItemId}`;
      }
    }
  }
}

// 支持商品链接的平台
export const isSupportItemSellerCenterURL = (channel: General.CaselessPlatformTunnel) => {
  const supported: General.CaselessPlatformTunnel[] = ['tokopedia', 'shopee', 'lazada'];
  return supported.includes(toLowerCase(channel));
};

export const isSupportSellerCenterURL = (channel: General.CaselessPlatformTunnel) => {
  const invalid =
    isTiKTok(channel) || channel === 'MERCADO' || channel === 'KWAI' || channel === 'JOLECT';
  return !invalid;
};

export const getSellerCenterURL = (channel: General.CaselessPlatformTunnel, storeId: string) => {
  if (channel === 'TOKOPEDIA') {
    openExternalURL(`https://seller.tokopedia.com`, '__blank');
    return;
  }
  return getStoreCNSCInfoById(storeId)
    .then((res) => {
      const {
        data: {
          storeInfo: { externalType, region, storeType, externalStoreId },
        },
      } = res;

      if (externalType === 'SHOPEE') {
        if (storeType === 'CROSS') {
          openExternalURL(`https://seller.shopee.cn/?cnsc_shop_id=${externalStoreId}`, '__blank');
        } else {
          let lcc = 'CN';
          if (localeCountryCode) {
            lcc = localeCountryCode;
          }

          let host = `https://seller.${toLowerCase(region)}.shopee.cn`;
          if (lcc !== 'CN') {
            const r = shopeeLocalSellerHostMap[toLowerCase(region)];
            if (r) {
              host = r;
            }
          }

          openExternalURL(host, '__blank');
        }
      }

      if (externalType === 'LAZADA') {
        if (storeType === 'CROSS') {
          openExternalURL(`https://gsp.lazada-seller.cn`, '__blank');
        } else {
          const host = lazadaSellerCenterHostMap[region];

          if (host) {
            openExternalURL(host, '__blank');
          }
        }
      }
    })
    .catch(() => {
      message.error(tolgee.t('sider.打开卖家中心失败，请稍后再试'));
    });
};
